import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';
// dependent on utc plugin
dayjs.extend(utc);
dayjs.extend(timezone);

export class DateUtil {
  static isBusinessDay(date: Date): boolean {
    const dayOfWeek = date.getDay();
    return dayOfWeek !== 0 && dayOfWeek !== 6; // 0 correspond au dimanche, 6 correspond au samedi
  }

  static addBusinessDays(startDate: Date, numDays: number): Date {
    let currentDate = dayjs(startDate); // Clonage de la date de départ pour éviter les effets secondaires

    // Boucle pour ajouter les jours ouvrés
    while (numDays > 0) {
      currentDate = currentDate.add(1, 'day');

      if (DateUtil.isBusinessDay(currentDate.toDate())) {
        numDays--; // Réduction du nombre de jours ouvrés restants si le jour est ouvré
      }
    }

    return currentDate.toDate();
  }
}
